export default function FortSmithTravelTimingSection() {
  return (
    <section id="timing" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Timing</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">When Fort Smith Travelers Need Passports</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { month: "Year-Round", title: "Military Deployments", desc: "Ebbing ANG personnel and families need passports on unpredictable military timelines." },
            { month: "March–April", title: "Spring Break", desc: "Families head to Cancun and the Caribbean. Rush orders peak mid-February through March." },
            { month: "May–June", title: "Summer Travel", desc: "Families plan European and cruise vacations. Corporate summer travel peaks." },
            { month: "July–August", title: "UAFS Study Abroad", desc: "International program students depart for fall semesters and summer programs." },
            { month: "September–October", title: "Off-Season", desc: "Ideal time for low-stress passport renewal before holiday travel." },
            { month: "November–December", title: "Holiday Rush", desc: "Winter cruises and holiday international travel. Emergency orders increase." },
          ].map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <p className="text-[#F6C344] text-xs font-bold uppercase tracking-wider mb-2">{t.month}</p>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{t.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}